import React from 'react';
import { HomeIcon, CalendarIcon, UserIcon, MessageSquareIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Navigation = () => {
  return <div className="border-t border-gray-300 fixed bottom-0 left-0 right-0 bg-white z-10" data-id="element-107">
      <div className="flex justify-around items-center h-16" data-id="element-108">
        <Link to="/" className="flex flex-col items-center p-2" data-id="element-109">
          <HomeIcon className="h-6 w-6 text-gray-700" data-id="element-110" />
          <span className="text-xs text-gray-700" data-id="element-111">Events</span>
        </Link>
        <Link to="/bookings" className="flex flex-col items-center p-2" data-id="element-112">
          <CalendarIcon className="h-6 w-6 text-gray-700" data-id="element-113" />
          <span className="text-xs text-gray-700" data-id="element-114">Bookings</span>
        </Link>
        <Link to="/messages" className="flex flex-col items-center p-2" data-id="element-115">
          <MessageSquareIcon className="h-6 w-6 text-gray-700" data-id="element-116" />
          <span className="text-xs text-gray-700" data-id="element-117">Messages</span>
        </Link>
        <Link to="/profile" className="flex flex-col items-center p-2" data-id="element-118">
          <UserIcon className="h-6 w-6 text-gray-700" data-id="element-119" />
          <span className="text-xs text-gray-700" data-id="element-120">Profile</span>
        </Link>
      </div>
    </div>;
};